<forge-scaffold class="dialog-scaffold">
  <forge-toolbar class="modal-header" slot="header">
    <div class="modal-title forge-typography--heading3" id="dialog-title" slot="start">Advanced search</div>
    <forge-icon-button slot="end" aria-label="Close dialog" (click)="closeDialog()">
      <forge-icon name="close" class="close-icon"></forge-icon>
    </forge-icon-button>
  </forge-toolbar>

  <div slot="body" id="dialog-message" class="modal-content">
    <form [formGroup]="searchForm">
      <!-- Top Section -->
      <div class="grid-3-col">
        <forge-text-field variant="outlined">
          <forge-icon name="search" slot="leading"></forge-icon>
          <label for="search-name">Search by name or alias</label>
          <input type="text" id="search-name" formControlName="nameOrId" />
        </forge-text-field>

        <forge-select variant="outlined" id="offender-type" label="Offender type" formControlName="offenderType">
          <forge-option value="">Any</forge-option>
          <forge-option *ngFor="let option of options.offenderType" [value]="option.value">{{ option.label
            }}</forge-option>
        </forge-select>

        <forge-text-field variant="outlined">
          <label for="doc-number">Department of corrections number</label>
          <input type="text" id="doc-number" formControlName="docNumber" />
        </forge-text-field>

        <forge-text-field variant="outlined">
          <label for="pid-number">Permanent ID number (PID)</label>
          <input type="text" id="pid-number" formControlName="pid" />
        </forge-text-field>

        <forge-select variant="outlined" id="supervision-status" label="Supervision status"
          formControlName="supervisionStatus">
          <forge-option value="">Any</forge-option>
          <forge-option *ngFor="let option of options.supervisionStatus" [value]="option.value">{{ option.label
            }}</forge-option>
        </forge-select>

        <forge-select variant="outlined" id="location-type" label="Location type" formControlName="locationType">
          <forge-option value="">Any</forge-option>
          <forge-option *ngFor="let option of options.locationType" [value]="option.value">{{ option.label
            }}</forge-option>
        </forge-select>

        <forge-select variant="outlined" id="facility" label="Facility" formControlName="facility">
          <forge-option value="">Any</forge-option>
          <forge-option *ngFor="let option of options.facility" [value]="option.value">{{ option.label }}</forge-option>
        </forge-select>

        <forge-select variant="outlined" id="supervision-county" label="County of supervision"
          formControlName="countyOfSupervision">
          <forge-option value="">Any</forge-option>
          <forge-option *ngFor="let option of options.countyOfSupervision" [value]="option.value">{{ option.label
            }}</forge-option>
        </forge-select>
      </div>

      <!-- Demographics Section -->
      <div>
        <div class="section-header-container">
          <div class="section-header">DEMOGRAPHICS</div>
        </div>
        <div class="grid-3-col align-items-end">
          <div class="age-range-container">
            <div class="section-label">Age range</div>
            <div class="age-range-inputs">
              <forge-select variant="outlined" id="min-age" label="Min. age" formControlName="minAge">
                <forge-option value="">Any</forge-option>
                <forge-option *ngFor="let age of ageOptions" [value]="age">{{ age }}</forge-option>
              </forge-select>
              <forge-select variant="outlined" id="max-age" label="Max. age" formControlName="maxAge">
                <forge-option value="">Any</forge-option>
                <forge-option *ngFor="let age of ageOptions" [value]="age">{{ age }}</forge-option>
              </forge-select>
            </div>
            <div class="error-text"
              *ngIf="searchForm.errors?.['ageRangeInvalid'] && (searchForm.get('minAge')?.touched || searchForm.get('maxAge')?.touched)">
              Min age cannot be greater than max age
            </div>
          </div>

          <div class="gender-container">
            <div class="section-label">Gender</div>
            <forge-button-toggle-group [value]="searchForm.get('gender')?.value"
              (forge-button-toggle-group-change)="searchForm.get('gender')?.setValue($event.detail)" stretch mandatory>
              <forge-button-toggle value="">Any</forge-button-toggle>
              <forge-button-toggle value="male">Male</forge-button-toggle>
              <forge-button-toggle value="female">Female</forge-button-toggle>
            </forge-button-toggle-group>
          </div>

          <forge-select variant="outlined" id="race" label="Race" formControlName="race">
            <forge-option value="">Any</forge-option>
            <forge-option *ngFor="let option of options.race" [value]="option.value">{{ option.label }}</forge-option>
          </forge-select>
        </div>
      </div>

      <!-- Conviction Information Section -->
      <div>
        <div class="section-header-container">
          <div class="section-header">CONVICTION INFORMATION</div>
        </div>
        <div class="grid-3-col">
          <forge-text-field variant="outlined">
            <label for="indictment-number">Indictment number</label>
            <input type="text" id="indictment-number" formControlName="indictmentNumber" />
          </forge-text-field>

          <forge-text-field variant="outlined">
            <label for="crime-offense">Crime or offense</label>
            <input type="text" id="crime-offense" formControlName="crimeOrOffense" />
          </forge-text-field>

          <forge-text-field variant="outlined">
            <label for="statute-code">Kentucky revised statute code</label>
            <input type="text" id="statute-code" formControlName="revisedStatuteCode" />
          </forge-text-field>

          <forge-select variant="outlined" id="conviction-county" label="Conviction county"
            formControlName="convictionCounty">
            <forge-option value="">Any</forge-option>
            <forge-option *ngFor="let option of options.convictionCounty" [value]="option.value">{{ option.label
              }}</forge-option>
          </forge-select>

          <forge-date-picker [min]="minDatePickerValue">
            <forge-text-field variant="outlined">
              <label for="crime-date">Crime date</label>
              <input type="text" id="crime-date" formControlName="crimeDate" />
            </forge-text-field>
          </forge-date-picker>

          <forge-date-picker [min]="minDatePickerValue">
            <forge-text-field variant="outlined">
              <label for="conviction-date">Conviction date</label>
              <input type="text" id="conviction-date" formControlName="convictionDate" />
            </forge-text-field>
          </forge-date-picker>

          <forge-date-picker [min]="minDatePickerValue">
            <forge-text-field variant="outlined">
              <label for="sentence-start-date">Sentence or supervision start date</label>
              <input type="text" id="sentence-start-date" formControlName="sentenceStartDate" />
            </forge-text-field>
          </forge-date-picker>

          <div class="date-range-container">
            <forge-date-range-picker [min]="minDatePickerValue" (forge-date-range-picker-change)="onDateRangeChange()">
              <forge-text-field variant="outlined" [invalid]="searchForm.hasError('escapedDateInvalid')">
                <label for="escaped-date-start">Escaped or absconded date</label>
                <input type="text" id="escaped-date-start" autocomplete="off" formControlName="escapedDateStart"
                  class="date-input-start" placeholder="mm/dd/yyyy" (keyup)="syncDate('escapedDateStart', $event)" />
                <input type="text" id="escaped-date-end" aria-label="Escaped or absconded end date" autocomplete="off"
                  formControlName="escapedDateEnd" placeholder="mm/dd/yyyy"
                  (keyup)="syncDate('escapedDateEnd', $event)" />
              </forge-text-field>
            </forge-date-range-picker>
            <div class="error-text" *ngIf="searchForm.hasError('escapedDateInvalid')">
              Start date cannot be after end date
            </div>
          </div>

          <div class="date-range-container">
            <forge-date-range-picker [min]="minDatePickerValue" (forge-date-range-picker-change)="onDateRangeChange()">
              <forge-text-field variant="outlined" [invalid]="searchForm.hasError('projectedReleaseDateInvalid')">
                <label for="projected-release-date-start">Projected release date</label>
                <input type="text" id="projected-release-date-start" autocomplete="off"
                  formControlName="projectedReleaseDateStart" class="date-input-start" placeholder="mm/dd/yyyy"
                  (keyup)="syncDate('projectedReleaseDateStart', $event)" />
                <input type="text" id="projected-release-date-end" aria-label="Projected release end date"
                  autocomplete="off" formControlName="projectedReleaseDateEnd" placeholder="mm/dd/yyyy"
                  (keyup)="syncDate('projectedReleaseDateEnd', $event)" />
              </forge-text-field>
            </forge-date-range-picker>
            <div class="error-text" *ngIf="searchForm.hasError('projectedReleaseDateInvalid')">
              Start date cannot be after end date
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div slot="footer" class="modal-footer">
    <forge-button variant="outlined" aria-label="Cancel" (click)="closeDialog()"
      class="cancel-button">Cancel</forge-button>
    <forge-button variant="raised" aria-label="Search" (click)="onSubmit()" [disabled]="searchForm.invalid"
      class="search-button">Search</forge-button>
  </div>
</forge-scaffold>

<div *ngIf="loading" class="advanced-search-loading" aria-live="polite">
  <forge-circular-progress aria-label="Loading filter options" size="48px"></forge-circular-progress>
  <span>Loading filter options…</span>
</div>